// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.criteria.RentalManagerUserPropertyCriteriaWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPropertyCriteriaGetResponseWebDto, UserPropertyCriteriaSetRequestWebDto } from '../..';

interface GetParams {
  listingAlias: ListingAlias;
}
interface SetParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyCriteriaWebApiHandler_get_Path = '/api/web/v1/users/properties/criteria/get';

/**
 * Get criteria for a listing
 */
export const RentalManagerUserPropertyCriteriaWebApiHandler_get = (getParams: GetParams, client = getClient()) => {
  return httpFrontEndRequest<GetParams, never, UserPropertyCriteriaGetResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyCriteriaWebApiHandler_get_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyCriteriaWebApiHandler_set_Path = '/api/web/v1/users/properties/criteria/set';

/**
 * Set criteria for a listing
 */
export const RentalManagerUserPropertyCriteriaWebApiHandler_set = (
  getParams: SetParams,
  postData: Array<UserPropertyCriteriaSetRequestWebDto>,
  client = getClient(),
) => {
  return httpFrontEndRequest<SetParams, Array<UserPropertyCriteriaSetRequestWebDto>, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyCriteriaWebApiHandler_set_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
